module.exports = __webpack_public_path__ + "img/6.57e56bbc.png";